import React from 'react'

import { PageOutputChartsTable } from '@ublique/components/Template'
import { useTranslation } from 'react-i18next'
import { useStripeTablesConfig } from './hooks/table'
import { TITLE } from './constants'

const TabellaDettaglio = () => {
  const { t } = useTranslation('OutputView')

  const { stripeTables } = useStripeTablesConfig()

  return (
    <PageOutputChartsTable
      className='ovs-tabella-dettaglio'
      title={t(`${TITLE}`)}
      stripeTables={stripeTables}
    />
  )
}

export default React.memo(TabellaDettaglio)
